var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "client_input" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input_list_pre" }, [
                  _c("ul", [
                    _c("li", { staticClass: "input_text" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.corpName,
                            expression: "form.corpName",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          maxlength: "32",
                          placeholder: "会社名"
                        },
                        domProps: { value: _vm.form.corpName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "corpName",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.corpName
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.corpName))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "input_text" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.postcd,
                            expression: "form.postcd",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          oninput: "if(value.length>7)value=value.slice(0,7)",
                          placeholder: "0001111"
                        },
                        domProps: { value: _vm.form.postcd },
                        on: {
                          keypress: _vm.validateNumber,
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "postcd",
                                $event.target.value.trim()
                              )
                            },
                            function($event) {
                              _vm.form.postcd = _vm.inputRestNumber($event)
                            }
                          ],
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.postcd
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.postcd))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "input_text2" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", { staticClass: "input_field" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.form.state,
                              expression: "form.state",
                              modifiers: { trim: true }
                            }
                          ],
                          attrs: { type: "text", placeholder: "都道府県" },
                          domProps: { value: _vm.form.state },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "state",
                                $event.target.value.trim()
                              )
                            },
                            blur: function($event) {
                              _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "space" }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.form.city,
                              expression: "form.city",
                              modifiers: { trim: true }
                            }
                          ],
                          attrs: { type: "text", placeholder: "市区町村" },
                          domProps: { value: _vm.form.city },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "city",
                                $event.target.value.trim()
                              )
                            },
                            blur: function($event) {
                              _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.errors.state
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.state))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "input_text" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.street,
                            expression: "form.street",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "以下、住所",
                          maxlength: "32"
                        },
                        domProps: { value: _vm.form.street },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "street",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.street
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.street))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "input_text2" }, [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("div", { staticClass: "input_field" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.form.userLastName,
                              expression: "form.userLastName",
                              modifiers: { trim: true }
                            }
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "32",
                            placeholder: "家具"
                          },
                          domProps: { value: _vm.form.userLastName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "userLastName",
                                $event.target.value.trim()
                              )
                            },
                            blur: function($event) {
                              _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "space" }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.form.userFirstName,
                              expression: "form.userFirstName",
                              modifiers: { trim: true }
                            }
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "32",
                            placeholder: "太郎"
                          },
                          domProps: { value: _vm.form.userFirstName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "userFirstName",
                                $event.target.value.trim()
                              )
                            },
                            blur: function($event) {
                              _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.errors.userName
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.userName))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "input_text2" }, [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("div", { staticClass: "input_field" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.form.userLastNameKana,
                              expression: "form.userLastNameKana",
                              modifiers: { trim: true }
                            }
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "32",
                            placeholder: "カグ"
                          },
                          domProps: { value: _vm.form.userLastNameKana },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "userLastNameKana",
                                $event.target.value.trim()
                              )
                            },
                            blur: function($event) {
                              _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "space" }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.form.userFirstNameKana,
                              expression: "form.userFirstNameKana",
                              modifiers: { trim: true }
                            }
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "32",
                            placeholder: "タロウ"
                          },
                          domProps: { value: _vm.form.userFirstNameKana },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "userFirstNameKana",
                                $event.target.value.trim()
                              )
                            },
                            blur: function($event) {
                              _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.errors.userNameKana
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.userNameKana))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "input_text" }, [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.tel,
                            expression: "form.tel",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          oninput: "if(value.length>11)value=value.slice(0,11)",
                          placeholder: "0123456789",
                          maxlength: "11"
                        },
                        domProps: { value: _vm.form.tel },
                        on: {
                          keypress: _vm.validateNumber,
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "tel",
                                $event.target.value.trim()
                              )
                            },
                            function($event) {
                              _vm.form.tel = _vm.inputRestNumber($event)
                            }
                          ],
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.tel
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.tel))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "input_text" }, [
                      _vm._m(7),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.email,
                            expression: "form.email",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "****@domans.co.jp",
                          maxlength: "128"
                        },
                        domProps: { value: _vm.form.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "email",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.email
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.email))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "input_text" }, [
                      _vm._m(8),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.form.department,
                            expression: "form.department",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "部署名",
                          maxlength: "11"
                        },
                        domProps: { value: _vm.form.department },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "department",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.department
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.department))
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control_btn_area" }, [
                  _c(
                    "div",
                    {
                      staticClass: "detail_btn2",
                      on: {
                        click: function($event) {
                          _vm.confirm()
                        }
                      }
                    },
                    [_vm._v("登録する")]
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("会社名")]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("郵便番号")]),
      _vm._v(" "),
      _c("span", { staticClass: "small_p" }, [
        _vm._v("（半角数値、ハイフン不要）")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("住所")]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("以下、住所")]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("氏名")]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("氏名（カナ）")]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("電話番号")]),
      _vm._v(" "),
      _c("span", { staticClass: "small_p" }, [
        _vm._v("（半角数値、ハイフン不要）")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("メールアドレス")]),
      _vm._v(" "),
      _c("span", { staticClass: "small_p" }, [
        _vm._v("（半角数値、ハイフン不要）")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", [_vm._v("部署名")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6dfb91e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6dfb91e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcClientInput.vue
// module id = null
// module chunks = 